module.exports = __webpack_public_path__ + "img/MX-specs-desktop.f3dc533b.jpg";